
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import AIAssistant from './AIAssistant';

const Hero: React.FC = () => {
  const [isAIOpen, setIsAIOpen] = useState(false);

  return (
    <section className="relative pt-32 sm:pt-52 pb-16 sm:pb-32 px-4 sm:px-6">
      <div className="glow-spot -top-40 -left-40 opacity-40"></div>
      <div className="glow-spot bottom-0 right-0 opacity-20"></div>
      
      <div className="container mx-auto relative z-10 text-center">
        <div className="inline-flex items-center space-x-4 px-4 py-2 rounded-full glass-card border border-white/5 mb-8 sm:mb-12 animate-slide-up">
           <span className="flex h-2 w-2 relative">
             <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#32dee6] opacity-75"></span>
             <span className="relative inline-flex rounded-full h-2 w-2 bg-[#32dee6]"></span>
           </span>
           <span className="mono text-[9px] sm:text-[10px] font-bold tracking-[0.2em] sm:tracking-[0.3em] uppercase text-gray-400">STATUS: VOICE_CORE_READY</span>
        </div>

        <h1 className="text-4xl sm:text-7xl lg:text-8xl font-extrabold tracking-tighter text-white leading-tight sm:leading-[1.2] mb-8 sm:mb-12 animate-slide-up uppercase">
          Automate Your <br className="hidden sm:block" />
          <div className="inline-block mt-2 sm:mt-4 px-4 sm:px-10 py-2 sm:py-3 relative">
            <span className="gradient-text">Business Operations.</span>
            <div className="absolute top-0 left-0 w-4 h-px bg-[#32dee6]/30"></div>
            <div className="absolute top-0 left-0 w-px h-4 bg-[#32dee6]/30"></div>
            <div className="absolute bottom-0 right-0 w-4 h-px bg-[#32dee6]/30"></div>
            <div className="absolute bottom-0 right-0 w-px h-4 bg-[#32dee6]/30"></div>
          </div>
        </h1>

        <div className="max-w-3xl mx-auto space-y-8 sm:space-y-10 animate-slide-up" style={{ animationDelay: '0.2s' }}>
          <p className="text-lg sm:text-2xl text-gray-400 font-light leading-relaxed px-4">
            Our mission is simple. Help teams reclaim their time by automating what’s repetitive, so they can focus on what matters.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 pt-4 sm:pt-6">
            <Link 
              to="/contact" 
              className="w-full sm:w-auto group relative px-8 py-4 sm:px-10 sm:py-5 bg-white/5 border border-white/10 text-white font-black text-xs sm:text-sm uppercase tracking-widest rounded-2xl overflow-hidden transition-all hover:border-[#32dee6] hover:bg-white hover:text-black"
            >
              <span className="relative z-10">Book Free Audit</span>
            </Link>
            
            <button 
              onClick={() => setIsAIOpen(true)}
              className="w-full sm:w-auto group relative px-8 py-4 sm:px-10 sm:py-5 bg-[#1d3fc4]/10 border border-[#1d3fc4]/30 text-[#32dee6] font-black text-xs sm:text-sm uppercase tracking-widest rounded-2xl overflow-hidden transition-all hover:bg-[#1d3fc4] hover:text-white flex items-center justify-center space-x-3"
            >
              <span className="relative z-10">Test Voice Core</span>
              <div className="w-1.5 h-1.5 rounded-full bg-[#32dee6] group-hover:bg-white animate-pulse"></div>
            </button>
          </div>
        </div>

        {/* Technical Marquee */}
        <div className="mt-20 sm:mt-32 w-full border-y border-white/5 py-4 sm:py-6 overflow-hidden bg-black/40">
           <div className="marquee flex space-x-12 sm:space-x-20 mono text-[9px] sm:text-[10px] font-bold text-gray-600 tracking-[0.3em] sm:tracking-[0.4em] uppercase">
             <span>VOICE_RECEPTION::STABLE</span>
             <span>CONCURRENT_CALLS::UNLIMITED</span>
             <span>LLM_LATENCY::0.8MS</span>
             <span>VOICE_ENGINE::V4.0</span>
             <span>CRM_BRIDGE::ACTIVE</span>
             <span>VOICE_RECEPTION::STABLE</span>
             <span>CONCURRENT_CALLS::UNLIMITED</span>
             <span>LLM_LATENCY::0.8MS</span>
             <span>VOICE_ENGINE::V4.0</span>
             <span>CRM_BRIDGE::ACTIVE</span>
           </div>
        </div>
      </div>

      <AIAssistant isOpen={isAIOpen} onClose={() => setIsAIOpen(false)} />
    </section>
  );
};

export default Hero;
